import { type ReactElement, useState } from 'react'
import { useDebounce } from '@hooks'
import { Stack, TextInput } from '@mantine/core'
import {
  type CloserStatus,
  type CompanyId,
  type TeamId,
  type TinyUser,
  type UserId,
  type UserSearchInput,
} from '@terros/common'
import { UsersList } from './UsersList'

export type PickUserSearchProps = {
  onSelect: (user: TinyUser) => void | Promise<void>
  onRemove?: (userId: UserId) => void | Promise<void>
  companyId?: CompanyId
  pickedUserIds?: UserId[]
  disabledUserIds?: UserId[]
  clearQueryOnSelect?: boolean
  closerStatus?: CloserStatus[]
  options?: UserSearchInput['options']
  onSelectAll?: (userIds: UserId[]) => void | Promise<void>
  onDeselectAll?: (userIds: UserId[]) => void | Promise<void>
  teamIds?: TeamId[]
}

export const PickUserSearch = ({
  onSelect,
  onRemove,
  clearQueryOnSelect,
  teamIds,
  ...props
}: PickUserSearchProps): ReactElement => {
  const [filter, setFilter] = useState('')
  const debounced = useDebounce(filter, 500)

  return (
    <Stack gap='xs'>
      <TextInput placeholder='Search users' value={filter} onChange={(e) => setFilter(e.currentTarget.value)} />

      <UsersList
        {...props}
        canRemove={Boolean(onRemove)}
        query={debounced}
        teamIds={teamIds}
        onRemove={async (userId) => {
          await onRemove?.(userId)
          if (clearQueryOnSelect) {
            setFilter('')
          }
        }}
        onSelect={async (userId) => {
          await onSelect(userId)
          if (clearQueryOnSelect) {
            setFilter('')
          }
        }}
      />
    </Stack>
  )
}
